import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAccount } from "@/redux/baseQuery";
import { transformOperators, transformOperator } from "./helpers";
import { GetOperatorsResponse, GetOperatorResponse, UpdateOperatorRequest } from "./types";

export const operatorApi = createApi({
  reducerPath: "operatorApi",
  baseQuery: baseQueryWithAccount("providers"),
  endpoints: (builder) => ({
    getOperators: builder.query<GetOperatorsResponse, void>({
      query: () => "?has_permissions=true&page_size=999",
      transformResponse: transformOperators,
      providesTags: ["Operators"],
    }),
    getOperator: builder.query<GetOperatorResponse, string>({
      query: (id) => `/${id}`,
      transformResponse: transformOperator,
    }),
    getClientOperators: builder.query<GetOperatorsResponse, void>({
      query: () => "?role=Passenger&sort=joined&direction=DESC&page_size=50",
      transformResponse: transformOperators,
      providesTags: ["Operators"],
    }),
    updateOperator: builder.mutation<GetOperatorResponse, { id: string } & UpdateOperatorRequest>({
      query: ({ id, ...body }) => ({
        url: `/${id}`,
        method: "PATCH",
        body,
      }),
      transformResponse: transformOperator,
      invalidatesTags: ["Operators"],
    }),
  }),
  tagTypes: ["Operators"],
});

export const {
  useLazyGetOperatorsQuery,
  useLazyGetOperatorQuery,
  useGetClientOperatorsQuery,
  useLazyGetClientOperatorsQuery,
  useUpdateOperatorMutation,
} = operatorApi;
